import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
const PMButton = styled.button`
  background: #ee754c;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    filter: brightness(0.95);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
function PaymentMethodManager({
  restaurantId
}) {
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const {
    userInfo
  } = useSelector(s => s.userLogin || {});
  const goToPortal = async () => {
    if (!userInfo?.token) {
      toast.error("Tens de iniciar sessão para gerir o método de pagamento.");
      return;
    }
    try {
      setLoading(true);
      const res = await fetch("/api/payments/portal-session/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${userInfo.token}`
        },
        body: JSON.stringify({
          restaurant_id: restaurantId
        })
        // if you're using cookies/session auth instead of JWT:
        // credentials: "include",
      });

      // handle non-JSON responses (e.g., HTML error/redirect)
      const ct = res.headers.get("content-type") || "";
      const payload = ct.includes("application/json") ? await res.json() : {
        error: await res.text()
      };
      if (!res.ok) {
        const msg = payload?.error || `Falha ao criar sessão (HTTP ${res.status} ${res.statusText})`;
        throw new Error(msg);
      }
      if (!payload?.url) {
        throw new Error("Resposta inválida do servidor (sem URL).");
      }
      window.location.href = payload.url;
    } catch (err) {
      toast.error(err.message || "Não foi possível abrir o portal de faturação.");
    } finally {
      setLoading(false);
    }
  };
  return <div>
      <p className="text-muted" style={{
      marginBottom: 8
    }}>{t("ui.components.paymentMethodManager.atualizaOMetodoDePagamentoE")}</p>
      <PMButton onClick={goToPortal} disabled={loading || !restaurantId}>
        {loading ? "A abrir..." : "Gerir pagamento e faturação"}
      </PMButton>
    </div>;
}
export default PaymentMethodManager;
